module.exports = __webpack_public_path__ + "static/img/group-mandy.532ae49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/group-mandy.png
// module id = KNIn
// module chunks = 1